<dropdown-action
  className="mx-2"
  *ngIf="(isShowComplete && viewIsf) || isShowDuplicate || isShowDelete || isShowContactSupport || showPrint"
  [iconColor]="iconColor"
  [menuMode]="viewIsf ? enumDropdownActionMenuMode.length : enumDropdownActionMenuMode.BLUE"
  [id]="'isf-action-' + isf.id"
  [ngClass]="{ 'show-in-list': showInList }"
>
  <button dropdown-item class="dropdown-item" (click)="printPage()" *ngIf="showPrint">
    {{ "BUTTON.PRINT_EXPORT_TO_PDF" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="completeIsf()" *ngIf="isShowComplete && viewIsf">
    {{ completeText | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="contactToSupport()" *ngIf="isShowContactSupport">
    {{ "BUTTON.CONTACT_US" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" [routerLink]="['/isf', isf.id]" *ngIf="showViewIsf">
    {{ "BUTTON.VIEW" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="duplicateIsf()" *ngIf="isShowDuplicate">
    {{ "BUTTON.DUPLICATE_ISF" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="createEntry()" *ngIf="isShowCreateEntry && viewIsf">
    {{ "BUTTON.CREATE_ENTRY" | translate }}
  </button>
  <button dropdown-item class="dropdown-item" (click)="openModal()" *ngIf="isShowDelete">{{ "BUTTON.DELETE" | translate }}</button>
</dropdown-action>
<custom-modal [(open)]="openDeleteModal" [header]="'LABELS.DELETE_ISF'" [type]="'error'">
  <div>{{ "DELETE_PAID_ISF" | translate }}</div>
  <button footer-action type="button" class="btn btn-secondary" (click)="onDecline()">
    {{ "BUTTON.NO_KEEP_IT" | translate | uppercase }}
  </button>
  <button footer-action type="button" class="btn btn-primary" (click)="delete()">{{ "BUTTON.YES_DELETE" | translate | uppercase }}</button>
</custom-modal>

<poa-required-modal [(open)]="showPoaRequiredModal" (discard)="onPoaModalDiscard()" (goToPoa)="onPoaModalGoToPoa()"></poa-required-modal>
